// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"b445fc80","472":"23fb1399","557":"b445fc80","751":"80e16b02","782":"9505ad1a","837":"babc4354"}[chunkId] + ".chunk.css";
};